import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStoreMetaTag } from '@types';

const initialState: IStoreMetaTag = {
  selectedMetaTags: [],
  aiRecommendedMetaTags: []
};

export const metaTagSlice = createSlice({
  name: 'metaTag',
  initialState,
  reducers: {
    initMetaTag: () => {
      return initialState;
    },

    setMetaTag: (state, action: PayloadAction<Partial<IStoreMetaTag>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { initMetaTag, setMetaTag } = metaTagSlice.actions;

export default metaTagSlice.reducer;
